/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import React from 'react';
import { ToolbarGroup, DropdownMenu, MenuItem, Popover } from '@wordpress/components';
/**
 * Options
 */
import { writingStyles, languages } from './options';
/**
 * Icons
 */
import icons from './icons.js';
import toolbaricons from './toolbar.icons.js';

const MoMoToolbar = ({
  languages,
  popoverAnchor
}) => {
	return (
		<Popover
		anchor={ popoverAnchor }
		>
          <DropdownMenu
            title={__('Translate', 'momoacg')}
			controls={languages.map((language) => ({
			  title: language.title,
			  onClick: () => handleChangeLanguage(language.value),
			}))}
          />
        </Popover>
	);
};

export default MoMoToolbar;